import apiClient from '../index';

export const guestApi = {
  // GET /guest-list — GuestlistController@index
  // Lists all guests for the current event (event_id resolved from uid header)
  // Supports pagination: page parameter (default 1) and search query
  getGuests: (page = 1, query = '') => apiClient.get(`/guests/list?page=${page}${query ? `&search=${encodeURIComponent(query)}` : ''}`),



  // GET /guests/{id} — GuestlistController@show
  getGuest: (id) => apiClient.get(`/guests/${id}`),

  // POST /guest-list/add — GuestlistController@addGuest
  // Adds a single guest with optional card_type, table_number, pledge, fund
  addGuest: (data) => apiClient.post('/guests/add', data),

  // POST /guest-list/upload-contacts — GuestlistController@uploadContacts
  // Bulk upload contacts (expects array of guest objects)
  uploadContacts: (contacts) => apiClient.post('/guests/upload-contacts', contacts),

  // PUT /guest-list/{id} — GuestlistController@update
  updateGuest: (id, data) => apiClient.put(`/guests/${id}`, data),

  // DELETE /guest-list/{id} — GuestlistController@destroy
  deleteGuest: (id) => apiClient.delete(`/guests/${id}`),

  // POST /guests/delete — GuestlistController@deleteMultiple
  // Sends raw array of guest IDs: [1, 2, 3] — backend reads via $request->all()
  deleteMultipleGuests: (ids) => apiClient.post('/guests/delete', ids),

  // POST /guest-list/rsvp — GuestlistController@rsvp
  // Expects { guest_id, rsvp } in request body
  updateRSVP: (guestId, rsvp) => apiClient.post('/guests/rsvp', { guest_id: guestId, rsvp }),

  // Invitation & notification endpoints
  getInvitations: () => apiClient.get('/guests/invitation'),
  sendInvitation: (data) => apiClient.post('/guests/invitations', data),
  getInvitedGuests: (page = 1, query = '') => apiClient.get(`/guests/invited?page=${page}${query ? `&search=${encodeURIComponent(query)}` : ''}`),

  // Attendance
  updateAttendance: (data) => apiClient.post('/guests/mark-attendance', data),
  getAttendance: () => apiClient.get('/guests/attendance'),

  // Thank-you notes
  sendThankYou: (data) => apiClient.post('/guests/send-thank-note', data),
  getThankYouNotes: () => apiClient.get('/guests/thank-note'),

  // Search by card number
  searchByCard: (cardNumber) => apiClient.post('/guests/search-bycard', { card_number: cardNumber }),
};

export const groupApi = {
  // Group CRUD
  getGroups: () => apiClient.get('/groups'),
  getGroup: (id) => apiClient.get(`/groups/${id}`),
  getGroupsByEvent: (eventId) => apiClient.get(`/groups/event/${eventId}`),
  createGroup: (data) => apiClient.post('/groups', data),
  updateGroup: (id, data) => apiClient.put(`/groups/${id}`, data),
  deleteGroup: (id) => apiClient.delete(`/groups/${id}`),

  // Group members
  addMember: (data) => apiClient.post('/groups/members', data),
  removeMember: (data) => apiClient.delete('/groups/members', { data }),
  getGuestGroups: (guestId) => apiClient.get(`/groups/guest/${guestId}`),
};

export default { guestApi, groupApi };